import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getUserOrganizationsAsPo } from '@api/users';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { USERS_ORGANIZATIONS_AS_PO } from '@constants/queryKeys';

interface IUseQueryUserOrganizationsAsPoReturned {
	userOrganizationOptions: Array<TSelectOption<string>>;
	isLoadingUserOrganizationOptions: boolean;
}

export const useQueryUserOrganizationsAsPo = (): IUseQueryUserOrganizationsAsPoReturned => {
	const {
		accessPermission: {
			platformOwnerAdministrator,
		},
	} = useAppSelector(auth);

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [USERS_ORGANIZATIONS_AS_PO],
		queryFn: getUserOrganizationsAsPo,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'id',
			labelKey: 'name',
		}),
		enabled: [platformOwnerAdministrator],
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		refetchOnWindowFocus: false,
	});

	return {
		userOrganizationOptions: data || [],
		isLoadingUserOrganizationOptions: isInitialLoading,
	};
};
